let orderHandlingTime = {
    '2-layer wood acrylic plaque': { '2-layer wood acrylic plaque': { type: 'cn', min: '2', max: '3' } },
    '2-layered mix ornament': { '2-layered mix ornament': { type: 'cn', min: '3', max: '5' } },
    '2-layered wooden ornament': {
      '2-layered wooden ornament': { type: 'cn', min: '3', max: '5' },
      'combo 2-layered wooden ornament': { type: 'cn', min: '3', max: '5' },
    },
    '30oz tumbler with handle': { '30oz tumbler with handle': { type: 'cn', min: '1', max: '3' } },
    '3d led light': { '3d led light wooden base': { type: 'cn', min: '2', max: '3' } },
    'accent mug': { 'accent mug': { type: 'cn', min: '1', max: '2' } },
    'acrylic bookmark': { 'acrylic bookmark': { type: 'cn', min: '2', max: '3' } },
    'acrylic car hanger': { 'acrylic car hanger': { type: 'cn', min: '2', max: '3' } },
    'acrylic car visor clip': { 'custom shaped acrylic car visor clip': { type: 'cn', min: '1', max: '3' } },
    'acrylic clipboard': { 'acrylic clipboard': { type: 'cn', min: '2', max: '3' } },
    'acrylic desk clock': { 'acrylic desk clock': { type: 'cn', min: '2', max: '3' } },
    'acrylic earrings': { 'acrylic earrings': { type: 'cn', min: '2', max: '3' } },
    'acrylic hanging suncatcher': { 'acrylic window hanging suncatcher': { type: 'cn', min: '2', max: '3' } },
    'acrylic insulated tumbler': { 'acrylic insulated tumbler with straw': { type: 'cn', min: '2', max: '3' } },
    'acrylic keychain': {
      'acrylic keychain': { type: 'cn', min: '2', max: '3' },
      'cutout acrylic keychain': { type: 'cn', min: '2', max: '3' },
      'acrylic tag keychain': { type: 'cn', min: '2', max: '3' },
    },
    'acrylic ornament': {
      'medallion acrylic ornament': { type: 'fast_cn', min: '1', max: '2' },
      'circle acrylic ornament': { type: 'fast_cn', min: '1', max: '2' },
      'custom shaped acrylic ornament': { type: 'fast_cn', min: '1', max: '2' },
    },
    'acrylic photo ornament': { 'acrylic photo ornament': { type: 'cn', min: '2', max: '3' } },
    'acrylic plaque': {
      'puzzle shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'dad shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'horizontal rectangle acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'vertical rectangle acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'heart shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'custom shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'rectangle shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'square shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'butterfly shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'heart infinity shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'family shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'paw shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'mom shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'round shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'nonagon shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'house shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
      'love-dad-shaped acrylic plaque': { type: 'cn', min: '2', max: '3' },
    },
    'acrylic plaque stake': { 'acrylic plaque stake': { type: 'cn', min: '2', max: '3' } },
    'acrylic shaker ornament': { '3-layered acrylic shaker ornament': { type: 'cn', min: '3', max: '5' } },
    'acrylic shaking stand': { 'acrylic shaking stand': { type: 'cn', min: '2', max: '3' } },
    'acrylic suncatcher ornament': { '2-layered acrylic suncatcher ornament': { type: 'cn', min: '3', max: '5' } },
    'acrylic wooden plaque': { 'custom shaped 2-layered acrylic wooden plaque': { type: 'cn', min: '2', max: '3' } },
    'air freshener': { 'photo air freshener': { type: 'cn', min: '2', max: '3' } },
    'aluminum keychain': { 'aluminum keychain': { type: 'cn', min: '2', max: '3' } },
    'aluminum ornament': { 'medallion aluminum ornament': { type: 'cn', min: '1', max: '3' } },
    'aluminum wallet card': { 'aluminum wallet card': { type: 'cn', min: '2', max: '3' } },
    apron: { apron: { type: 'cn', min: '2', max: '3' } },
    'auto sunshade': { 'auto sunshade': { type: 'cn', min: '2', max: '3' } },
    'baby onesie': { 'baby onesie': { type: 'cn', min: '1', max: '3' } },
    backpack: { 'canvas backpack': { type: 'cn', min: '3', max: '5' } },
    'bangle bracelet cuff': { 'bangle bracelet cuff': { type: 'cn', min: '2', max: '3' } },
    'baseball, softball': { 'baseball, softball': { type: 'cn', min: '3', max: '5' } },
    'beach bag': { 'beach bag': { type: 'cn', min: '3', max: '5' } },
    'beach short': {
      'women beach shorts': { type: 'cn', min: '3', max: '5' },
      'unisex beach shorts': { type: 'cn', min: '3', max: '5' },
      'couple beach shorts': { type: 'cn', min: '3', max: '5' },
    },
    'beach towel': { 'beach towel': { type: 'cn', min: '2', max: '3' } },
    beanie: { 'beanie with leather patch': { type: 'cn', min: '2', max: '3' } },
    'beanie hat': { 'bobble beanie hat': { type: 'cn', min: '3', max: '5' } },
    'beer glass': { 'beer glass': { type: 'cn', min: '2', max: '3' } },
    'bifold wallet': {
      'bifold wallet': { type: 'cn', min: '2', max: '3' },
      'leather wallet': { type: 'cn', min: '2', max: '3' },
    },
    'birthstone charm necklace': { 'birthstone charm necklace': { type: 'cn', min: '2', max: '3' } },
    'blue bottle light': { 'blue bottle light': { type: 'cn', min: '2', max: '3' } },
    'bottle carrier bag': { 'bottle carrier bag': { type: 'cn', min: '1', max: '3' } },
    'bottle light': { 'bottle light': { type: 'cn', min: '1', max: '3' } },
    'bottle opener keychain': { 'bottle opener keychain': { type: 'cn', min: '2', max: '3' } },
    'bottle opener wood level': { 'bottle opener wood level': { type: 'cn', min: '2', max: '3' } },
    'boxer briefs': { "men's boxer briefs": { type: 'cn', min: '3', max: '5' } },
    'bucket hat': { 'bucket hat': { type: 'cn', min: '3', max: '5' } },
    'building brick blocks': {
      'heart building brick blocks': { type: 'cn', min: '2', max: '3' },
      'horizontal rectangle building brick blocks': { type: 'cn', min: '2', max: '3' },
      'square shaped building brick blocks': { type: 'cn', min: '2', max: '3' },
      'vertical rectangle building brick blocks': { type: 'cn', min: '2', max: '3' },
    },
    'camping picnic blanket': { 'outdoor waterproof camping picnic blanket': { type: 'cn', min: '3', max: '5' } },
    'can cooler tumbler': { '4 in 1 can cooler tumbler': { type: 'cn', min: '2', max: '3' } },
    'candle holder': { 'candle holder': { type: 'cn', min: '2', max: '3' } },
    canvas: { canvas: { type: 'us', min: '2', max: '3' } },
    'canvas tote bag': { 'canvas tote bag': { type: 'cn', min: '3', max: '5' } },
    'car visor clip': { 'custom shaped car visor clip': { type: 'cn', min: '1', max: '3' } },
    'card keeper': { 'card keeper, card holder': { type: 'cn', min: '2', max: '3' } },
    'card wallet': {
      'card wallet': { type: 'cn', min: '2', max: '3' },
      'card wallet with money clip': { type: 'cn', min: '2', max: '3' },
    },
    cardigan: { cardigan: { type: 'cn', min: '3', max: '5' } },
    'cardstock with wooden stand': { 'custom shaped cardstock with wooden stand': { type: 'cn', min: '2', max: '3' } },
    'ceramic ornament': {
      'circle ceramic ornament': { type: 'fast_cn', min: '1', max: '2' },
      'combo circle ceramic ornament set': { type: 'cn', min: '1', max: '3' },
      'star ceramic ornament': { type: 'cn', min: '1', max: '3' },
      'heart ceramic ornament': { type: 'fast_cn', min: '1', max: '2' },
      'tree ceramic ornament': { type: 'cn', min: '1', max: '3' },
      'oval ceramic ornament': { type: 'cn', min: '1', max: '3' },
      'snowflake ceramic ornament': { type: 'cn', min: '1', max: '3' },
      'bell ceramic ornament': { type: 'cn', min: '1', max: '3' },
      'medallion ceramic ornament': { type: 'cn', min: '1', max: '3' },
      'combo heart ceramic ornament': { type: 'cn', min: '1', max: '3' },
    },
    'ceramic plant pot': { 'ceramic plant pot': { type: 'cn', min: '2', max: '3' } },
    'ceramic plate': { 'ceramic plate': { type: 'cn', min: '2', max: '3' } },
    'charm bracelet': { 'charm bracelet': { type: 'cn', min: '2', max: '3' } },
    'christmas stocking': { 'christmas stocking': { type: 'cn', min: '2', max: '3' } },
    'classic cap': { 'classic cap': { type: 'cn', min: '3', max: '5' }, 'default': { type: 'cn', min: '3', max: '5' } },
    'clear flat ball ornament': { 'clear flat ball ornament': { type: 'cn', min: '2', max: '3' } },
    'clear glass can': { 'clear glass can': { type: 'cn', min: '2', max: '3' } },
    'clear phone case': {
      'clear phone case': { type: 'cn', min: '1', max: '3' },
      'clear couple phone case': { type: 'cn', min: '1', max: '3' },
    },
    'collar frame': {
      'pet loss sign, collar frame': { type: 'cn', min: '2', max: '3' },
      'rectangle pet loss sign, collar frame': { type: 'cn', min: '2', max: '3' },
    },
    'color changing cup': { 'aluminum color changing cup': { type: 'cn', min: '2', max: '3' } },
    'color changing mug': { 'color changing mug': { type: 'us', min: '2', max: '3' } },
    'combo leather wallet & bag': { 'combo leather wallet and bag': { type: 'cn', min: '3', max: '5' } },
    'combo leather wallet & tote bag': { 'combo leather wallet and tote bag': { type: 'cn', min: '3', max: '5' } },
    'combo luggage cover and tag': { 'combo luggage cover and luggage tag': { type: 'cn', min: '3', max: '5' } },
    'combo marble mug & serving board': { 'combo marble mug & serving board': { type: 'cn', min: '2', max: '3' } },
    'combo wine & beer glass': { 'combo wine & beer glass': { type: 'cn', min: '2', max: '3' } },
    'combo wine & whiskey glass': { 'combo wine & whiskey glass': { type: 'cn', min: '1', max: '3' } },
    'compact mirror': {
      'square compact mirror': { type: 'cn', min: '2', max: '3' },
      'heart shaped compact mirror': { type: 'cn', min: '2', max: '3' },
      'circle compact mirror': { type: 'cn', min: '2', max: '3' },
    },
    'cookie jar': { 'cookie jar': { type: 'cn', min: '2', max: '3' } },
    'cosmetic bag': { 'cosmetic bag': { type: 'cn', min: '2', max: '3' } },
    'couple underwear briefs': { 'couple matching underwear briefs': { type: 'cn', min: '3', max: '5' } },
    'crochet hanging decoration': { 'crochet cardinal bird hanging decoration': { type: 'cn', min: '2', max: '3' } },
    'crossbody belt bag': { 'crossbody belt bag': { type: 'cn', min: '3', max: '5' } },
    'crystal candle holder': { 'crystal candle holder': { type: 'cn', min: '2', max: '3' } },
    'crystal heart': { 'crystal heart': { type: 'cn', min: '2', max: '3' } },
    'curtain set': { 'curtain valance and tiers set': { type: 'cn', min: '2', max: '3' } },
    'custom cutout vinyl sticker': { 'custom cutout vinyl sticker': { type: 'cn', min: '2', max: '3' } },
    'custom shaped led light': { 'custom shaped led light': { type: 'cn', min: '2', max: '3' } },
    'custom shaped metal sign': { 'custom shaped metal sign': { type: 'cn', min: '2', max: '3' } },
    'cutout acrylic ornament': { 'cutout acrylic ornament': { type: 'fast_cn', min: '1', max: '2' } },
    'cutout metal sign': { 'cutout metal sign': { type: 'cn', min: '2', max: '3' } },
    'cutout mirror acrylic ornament': { 'diy mirror acrylic ornament': { type: 'cn', min: '2', max: '3' } },
    'decor decal': { 'decor decal': { type: 'cn', min: '2', max: '3' } },
    'desk name plate': { 'desk name plate': { type: 'cn', min: '2', max: '3' } },
    'dog shaped lamp': {
      'custom corgi lamp': { type: 'cn', min: '3', max: '5' },
      'custom dachshund lamp': { type: 'cn', min: '3', max: '5' },
      'custom french bulldog lamp': { type: 'cn', min: '3', max: '5' },
      'custom labrador retriever lamp': { type: 'cn', min: '3', max: '5' },
      'custom german shepherd lamp': { type: 'cn', min: '3', max: '5' },
      'custom pug lamp': { type: 'cn', min: '3', max: '5' },
      'custom beagle lamp': { type: 'cn', min: '3', max: '5' },
      'custom golden retriever lamp': { type: 'cn', min: '3', max: '5' },
      'custom poddle lamp': { type: 'cn', min: '3', max: '5' },
      'custom chihuahua lamp': { type: 'cn', min: '3', max: '5' },
    },
    'doll crochet with card': { 'doll crochet with custom card': { type: 'cn', min: '2', max: '3' } },
    'door cover': { 'door cover': { type: 'cn', min: '3', max: '5' } },
    doormat: {
      doormat: { type: 'cn', min: '1', max: '3' },
      'custom shaped doormat': { type: 'cn', min: '1', max: '3' },
      'custom shaped photo doormat': { type: 'cn', min: '1', max: '3' },
    },
    'duffle bag': {
      'duffle bag': { type: 'cn', min: '3', max: '5' },
      'combo 2 duffle bags': { type: 'cn', min: '3', max: '5' },
    },
    'embossed ceramic ornament': { 'embossed ceramic ornament': { type: 'cn', min: '2', max: '3' } },
    'embroidered sweatshirt': { 'embroidered sweatshirt': { type: 'cn', min: '3', max: '5' } },
    'engraved 40oz tumbler': { 'engraved 40oz tumbler': { type: 'cn', min: '3', max: '5' } },
    'engraved bracelet': { 'engraved bracelet': { type: 'cn', min: '1', max: '3' } },
    'engraved leather belt': { 'engraved leather belt': { type: 'cn', min: '2', max: '3' } },
    'engraved leather wallet': { 'engraved leather wallet': { type: 'cn', min: '2', max: '3' } },
    'everlasting rose dome lamp': { 'everlasting rose dome lamp': { type: 'cn', min: '1', max: '3' } },
    'fabric lamp': { 'fabric lamp': { type: 'cn', min: '3', max: '5' } },
    "father's day gift set": { "father's day gift set": { type: 'us', min: '1', max: '3' } },
    'favor bag': { 'favor bag': { type: 'cn', min: '2', max: '3' } },
    'film roll keychain': { 'film roll keychain': { type: 'cn', min: '2', max: '3' } },
    flag: { flag: { type: 'cn', min: '2', max: '3' } },
    'fleece blanket': { 'fleece blanket, sherpa blanket': { type: 'cn', min: '3', max: '5' } },
    'flower shadow box': { 'flower shadow box': { type: 'cn', min: '2', max: '3' } },
    'flower vase': { 'ceramic flower vase': { type: 'cn', min: '2', max: '3' } },
    'fluffy slippers': { 'fluffy slippers': { type: 'cn', min: '3', max: '5' } },
    'folding chair cover': { 'folding chair cover': { type: 'cn', min: '3', max: '5' } },
    'frame lamp': {
      'frame lamp': { type: 'cn', min: '2', max: '3' },
      'horizontal frame lamp': { type: 'cn', min: '2', max: '3' },
    },
    'frosted glass can': { 'ombre frosted glass can': { type: 'cn', min: '2', max: '3' } },
    'full print t shirt': { 'full print t shirt': { type: 'cn', min: '3', max: '5' } },
    'garden slate & hook': {
      'heart shaped garden slate & hook': { type: 'cn', min: '2', max: '3' },
      'oval shaped garden slate & hook': { type: 'cn', min: '2', max: '3' },
    },
    'gem heart cuff bracelet': { 'gem heart cuff bracelet': { type: 'cn', min: '2', max: '3' } },
    'glass bauble ornament': { 'glass bauble ornament': { type: 'cn', min: '2', max: '3' } },
    'glass flower tea cup': { 'glass flower tea cup': { type: 'cn', min: '2', max: '3' } },
    'glass mug': { 'glass mug': { type: 'cn', min: '1', max: '3' } },
    'glass ornament': {
      'circle glass ornament': { type: 'fast_cn', min: '1', max: '2' },
      'stained effect printed circle glass ornament': { type: 'cn', min: '1', max: '3' },
      'heart shaped glass ornament': { type: 'fast_cn', min: '1', max: '2' },
      'combo circle glass ornament': { type: 'cn', min: '1', max: '3' },
      'medallion glass ornament': { type: 'fast_cn', min: '1', max: '2' },
      'glass ornament': { type: 'fast_cn', min: '1', max: '2' },
      'onesie shaped glass ornament': { type: 'cn', min: '1', max: '3' },
      'snowflakes shaped glass ornament': { type: 'cn', min: '1', max: '3' },
      'oval glass ornament': { type: 'cn', min: '1', max: '3' },
    },
    'glasses case box': { 'chrome glasses case box': { type: 'cn', min: '2', max: '3' } },
    'glitter plastic ornament': { 'glitter plastic ornament': { type: 'cn', min: '2', max: '3' } },
    'golf ball': { 'golf ball': { type: 'cn', min: '1', max: '3' } },
    'golf ball stamp': { 'golf ball stamp with metal storage box': { type: 'cn', min: '2', max: '3' } },
    'golf towel': { 'golf towel': { type: 'cn', min: '2', max: '3' } },
    'graduation cap topper': { 'graduation cap topper': { type: 'cn', min: '2', max: '3' } },
    'graduation tassel charm': { 'graduation tassel charm': { type: 'cn', min: '2', max: '3' } },
    'graduation tassel pin': { 'graduation tassel pin': { type: 'cn', min: '2', max: '3' } },
    'hawaii set shirt and shorts': { 'hawaii set shirt and shorts': { type: 'cn', min: '3', max: '5' } },
    'hawaiian shirt': { 'hawaiian shirt': { type: 'cn', min: '3', max: '5' } },
    'heart bracelet': { 'heart bracelet': { type: 'cn', min: '2', max: '3' } },
    'heart slate garden stake': { 'heart slate garden stake': { type: 'cn', min: '2', max: '3' } },
    'hip flask': { 'hip flask': { type: 'cn', min: '2', max: '3' } },
    'hockey puck bottle opener': { 'hockey puck bottle opener': { type: 'cn', min: '2', max: '3' } },
    'hologram sticker': { 'custom peel-out hologram sticker': { type: 'cn', min: '2', max: '3' } },
    'holographic acrylic ornament': { 'holographic acrylic ornament': { type: 'cn', min: '2', max: '3' } },
    'holographic acrylic plaque': { 'holographic acrylic plaque': { type: 'cn', min: '2', max: '3' } },
    'holographic tote': { 'holographic tote': { type: 'cn', min: '2', max: '3' } },
    'hooded beach towel': { 'hooded beach towel': { type: 'cn', min: '3', max: '5' } },
    'jewelry box': {
      'jewelry box': { type: 'cn', min: '1', max: '3' },
      'glass jewelry box': { type: 'cn', min: '1', max: '3' },
    },
    'jewelry box with handle': { 'jewelry box with handle': { type: 'cn', min: '1', max: '3' } },
    'jigsaw puzzle': { 'jigsaw puzzle': { type: 'cn', min: '2', max: '3' } },
    'jute beach bag': { 'jute beach bag': { type: 'cn', min: '3', max: '5' } },
    'jute tote bag': { 'jute tote bag': { type: 'cn', min: '2', max: '3' } },
    'keepsake keychain': { 'keepsake keychain': { type: 'cn', min: '2', max: '3' } },
    'keepsake necklace': { 'keepsake necklace': { type: 'cn', min: '2', max: '3' } },
    keyring: { keyring: { type: 'cn', min: '2', max: '3' } },
    'kids lunch bag': { 'kids lunch bag': { type: 'cn', min: '2', max: '3' } },
    'kids water bottle': { 'kids water bottle': { type: 'cn', min: '2', max: '3' } },
    'kids water bottle with straw': { 'kids water bottle with straw': { type: 'cn', min: '2', max: '3' } },
    'lantern ornament': { 'candlelight lantern ornament': { type: 'cn', min: '2', max: '3' } },
    'laundry basket': { 'laundry basket, storage basket': { type: 'cn', min: '3', max: '5' } },
    'leather bag': { 'leather bag': { type: 'cn', min: '3', max: '5' } },
    'leather baseball keychain': { 'leather baseball keychain': { type: 'cn', min: '3', max: '5' } },
    'leather braided bracelet': { 'leather braided bracelet': { type: 'cn', min: '2', max: '3' } },
    'leather can cooler': { 'leather can cooler': { type: 'cn', min: '2', max: '3' } },
    'leather coordinates keychain': { 'leather coordinates keychain': { type: 'cn', min: '2', max: '3' } },
    'leather flip wallet phone case': { 'leather flip wallet phone case': { type: 'cn', min: '1', max: '3' } },
    'leather handle tote bag': { 'leather handle tote bag': { type: 'cn', min: '3', max: '5' } },
    'leather journal': { 'leather journal': { type: 'cn', min: '1', max: '3' } },
    'leather keychain': {
      'leather keychain': { type: 'cn', min: '2', max: '3' },
      'custom shaped leather keychain': { type: 'cn', min: '2', max: '3' },
    },
    'leather keychain with stitching': {
      'custom shaped leather keychain with stitching': { type: 'cn', min: '2', max: '3' },
      'paw shaped leather keychain with stitching': { type: 'cn', min: '2', max: '3' },
      'tag shaped leather keychain with stitching': { type: 'cn', min: '2', max: '3' },
    },
    'leather long wallet': { 'leather long wallet': { type: 'cn', min: '3', max: '5' } },
    'leather makeup bag': { 'leather makeup bag': { type: 'cn', min: '1', max: '3' } },
    'leather patch hat': { 'leather patch hat': { type: 'cn', min: '3', max: '5' } },
    'leather photo keychain': { 'leather photo keychain': { type: 'cn', min: '2', max: '3' } },
    'leather pocket hug': { 'leather pocket hug': { type: 'cn', min: '2', max: '3' } },
    'leather toiletry bag': { 'leather toiletry bag': { type: 'cn', min: '2', max: '3' } },
    'leather tote bag': { 'leather tote bag': { type: 'cn', min: '3', max: '5' } },
    'leather tumbler': { 'leather tumbler': { type: 'cn', min: '2', max: '3' } },
    'leather valet tray': { 'leather valet tray': { type: 'cn', min: '2', max: '3' } },
    'led candle': { 'flameless led candle': { type: 'cn', min: '1', max: '3' } },
    'led candle lantern': { 'led candle lantern': { type: 'cn', min: '2', max: '3' } },
    'led light flower shadow box': { 'led light flower shadow box': { type: 'cn', min: '2', max: '3' } },
    'led light wooden plaque': { 'led light wooden plaque': { type: 'cn', min: '2', max: '3' } },
    'led pendant light': { 'led pendant light': { type: 'cn', min: '2', max: '3' } },
    leggings: { leggings: { type: 'cn', min: '3', max: '5' } },
    'letter necklace': { 'letter necklace': { type: 'cn', min: '2', max: '3' } },
    'license plate': { 'license plate': { type: 'cn', min: '2', max: '3' } },
    'light box': { 'custom shaped light box': { type: 'cn', min: '2', max: '3' } },
    'light up picture frame': { 'light up picture frame': { type: 'cn', min: '2', max: '3' } },
    'locket necklace': { 'locket necklace': { type: 'cn', min: '2', max: '3' } },
    'loungewear set': { 'loungewear set': { type: 'cn', min: '3', max: '5' } },
    'low-waisted brief': { "women's low-waisted brief": { type: 'cn', min: '3', max: '5' } },
    'lowball tumbler': { 'lowball tumbler': { type: 'cn', min: '2', max: '3' } },
    'luggage cover': {
      'luggage cover': { type: 'cn', min: '3', max: '5' },
      'combo 2 luggage covers': { type: 'cn', min: '3', max: '5' },
      'clear luggage cover': { type: 'cn', min: '3', max: '5' },
      'combo 2 clear luggage covers': { type: 'cn', min: '3', max: '5' },
    },
    'luggage handle wrap': { 'luggage handle wrap': { type: 'cn', min: '3', max: '5' } },
    'luggage tag': {
      'luggage tag': { type: 'cn', min: '1', max: '3' },
      'combo 2 luggage tags': { type: 'cn', min: '1', max: '3' },
    },
    'lunch bag, cooling tote': { 'lunch bag, cooling tote': { type: 'cn', min: '2', max: '3' } },
    magnet: { magnet: { type: 'cn', min: '2', max: '3' } },
    'mailbox cover': { 'mailbox cover': { type: 'cn', min: '2', max: '3' } },
    'makeup box': { 'makeup box with led mirror': { type: 'cn', min: '2', max: '3' } },
    'marble mug': { 'marble mug': { type: 'cn', min: '1', max: '3' } },
    'mason jar cup': { 'mason jar cup with straw': { type: 'cn', min: '2', max: '3' } },
    'mason jar light': { 'mason jar light': { type: 'cn', min: '1', max: '3' } },
    'memorial bench': { 'memorial bench': { type: 'cn', min: '2', max: '3' } },
    'memorial garden stone': {
      'circle memorial garden stone': { type: 'cn', min: '2', max: '3' },
      'heart memorial garden stone': { type: 'cn', min: '2', max: '3' },
      'rectangle memorial garden stone': { type: 'cn', min: '2', max: '3' },
    },
    'mesh-back casual cap': { 'mesh-back casual cap': { type: 'cn', min: '3', max: '5' } },
    'metal garden stake': { 'metal garden stake': { type: 'cn', min: '3', max: '5' } },
    'metal sign': {
      'classic metal signs': { type: 'cn', min: '2', max: '3' },
      'butterfly shaped metal sign': { type: 'cn', min: '2', max: '3' },
    },
    'mini photo album keychain': { 'mini photo album keychain': { type: 'cn', min: '2', max: '3' } },
    'mirror frame lamp': { 'led mirror frame lamp': { type: 'cn', min: '2', max: '3' } },
    'mirror ornament': {
      'mirror ornament': { type: 'cn', min: '2', max: '3' },
      'custom shaped mirror ornament': { type: 'cn', min: '2', max: '3' },
    },
    mug: {
      mug: { type: 'us', min: '1', max: '2' },
      'white edge-to-edge mug': { type: 'us', min: '1', max: '2' },
      'black mug': { type: 'us', min: '1', max: '2' },
    },
    'music box': { 'spin button, hand crank music box': { type: 'cn', min: '2', max: '3' } },
    'ornament with wooden tag': { 'mix ornament with wooden tag': { type: 'cn', min: '3', max: '5' } },
    'oven mitts, pot holder': { 'oven mitts, pot holders': { type: 'cn', min: '3', max: '5' } },
    'oversized blanket': { 'oversized blanket': { type: 'cn', min: '3', max: '5' } },
    'pajama pants': {
      'pajama pants': { type: 'cn', min: '3', max: '5' },
      'kid pajama pants': { type: 'cn', min: '3', max: '5' },
    },
    pajamas: {
      'long pajamas set': { type: 'cn', min: '3', max: '5' },
      'kid pajamas set': { type: 'cn', min: '3', max: '5' },
      'unisex pajamas set': { type: 'cn', min: '3', max: '5' },
    },
    'passport holder': { 'passport cover, passport holder': { type: 'cn', min: '1', max: '3' } },
    'pencil case': { 'pencil case': { type: 'cn', min: '3', max: '5' } },
    'pendant charm': { 'photo pendant charm': { type: 'cn', min: '2', max: '3' } },
    'pet blanket': { 'pet blanket': { type: 'cn', min: '3', max: '5' } },
    'pet bowl': { 'pet bowl': { type: 'cn', min: '2', max: '3' } },
    'pet shirt': { 'pet shirt': { type: 'cn', min: '3', max: '5' } },
    'picture frame light box': { 'picture frame light box': { type: 'cn', min: '2', max: '3' } },
    pillow: {
      'heart shaped pillow': { type: 'cn', min: '3', max: '5' },
      pillow: { type: 'cn', min: '3', max: '5' },
      'custom shaped pillow': { type: 'cn', min: '3', max: '5' },
      'paw shaped pillow': { type: 'cn', min: '3', max: '5' },
      'sequin pillow, mermaid sequin cushion magic reversible throw pillow': { type: 'cn', min: '3', max: '5' },
      'cloud shaped pillow': { type: 'cn', min: '3', max: '5' },
    },
    'pilsner glass': { 'pilsner glass': { type: 'cn', min: '2', max: '3' } },
    'plant pot ceramic mug': { 'plant pot ceramic mug': { type: 'cn', min: '2', max: '3' } },
    'plastic pinback button': { 'plastic pinback button': { type: 'cn', min: '2', max: '3' } },
    plate: { plate: { type: 'cn', min: '1', max: '3' } },
    'plug-in night light': { 'plug-in night light': { type: 'cn', min: '2', max: '3' } },
    'pocket dress': { 'pocket dress': { type: 'cn', min: '3', max: '5' } },
    'pocket pillow': { 'pocket pillow': { type: 'cn', min: '3', max: '5' } },
    'pocket watch': { 'pocket watch': { type: 'cn', min: '2', max: '3' } },
    'polo shirt': { 'polo shirt': { type: 'cn', min: '3', max: '5' } },
    poster: { poster: { type: 'cn', min: '1', max: '3' } },
    'pottery mug': { 'pottery mug': { type: 'cn', min: '2', max: '3' } },
    'printed rock': { 'printed rock': { type: 'cn', min: '1', max: '3' } },
    'pullover hoodie': { 'pullover hoodie': { type: 'cn', min: '3', max: '5' } },
    'puzzle necklace set': { 'heart puzzle necklace set': { type: 'cn', min: '2', max: '3' } },
    'quilt bedding': { 'quilt bedding': { type: 'cn', min: '3', max: '5' } },
    'rain jacket': { 'rain jacket': { type: 'cn', min: '3', max: '5' } },
    'rainbow suncatcher': { 'window hanging rainbow suncatcher': { type: 'cn', min: '2', max: '3' } },
    'rainbow suncatcher & crystal': {
      'rainbow suncatcher with crystal ball prism': { type: 'cn', min: '2', max: '3' },
    },
    'rectangle led light': { 'rectangle led light': { type: 'cn', min: '2', max: '3' } },
    'ring dish': {
      'ring dish': { type: 'cn', min: '1', max: '3' },
      'heart ring dish': { type: 'cn', min: '1', max: '3' },
      'round ring dish': { type: 'cn', min: '1', max: '3' },
    },
    'rocks whiskey glass': { 'rocks whiskey glass': { type: 'cn', min: '2', max: '3' } },
    'rotating pen holder': { 'rotating pen holder': { type: 'cn', min: '2', max: '3' } },
    'round pillow': { 'round pillow': { type: 'cn', min: '3', max: '5' } },
    'round rattan bag': { 'round rattan bag': { type: 'cn', min: '2', max: '3' } },
    'sarong swimwear': { 'short sarong swimwear cover ups': { type: 'cn', min: '3', max: '5' } },
    'satin pajama set': { 'satin pajama set': { type: 'cn', min: '3', max: '5' } },
    'scented candle': { 'scented candle with wooden lid': { type: 'cn', min: '2', max: '3' } },
    'school sign': { 'school sign': { type: 'cn', min: '2', max: '3' } },
    'serving board with cup holder': { 'serving board with cup holder': { type: 'cn', min: '2', max: '3' } },
    'short pajamas': {
      'short pajamas set': { type: 'cn', min: '3', max: '5' },
      'pajama shorts': { type: 'cn', min: '3', max: '5' },
    },
    'short sleeve sweater': { 'short sleeve sweater': { type: 'cn', min: '3', max: '5' } },
    'shot glass': { 'shot glass': { type: 'cn', min: '2', max: '3' } },
    'sleeveless tank dress': { 'sleeveless tank dress': { type: 'cn', min: '3', max: '5' } },
    'soccer ball': { 'soccer ball': { type: 'cn', min: '3', max: '5' } },
    socks: { socks: { type: 'cn', min: '3', max: '5' }, 'socks combo 2 pairs': { type: 'cn', min: '3', max: '5' } },
    'soft toy bunny': { 'soft toy bunny': { type: 'cn', min: '2', max: '3' } },
    'solar light': { 'solar light': { type: 'cn', min: '2', max: '3' } },
    'stained glass ornament': { 'stained glass ornament': { type: 'cn', min: '1', max: '3' } },
    'stained glass suncatcher': {
      'stained glass window hanging suncatcher': { type: 'cn', min: '1', max: '3' },
      'horizontal stained glass suncatcher': { type: 'cn', min: '1', max: '3' },
      'vertical stained glass suncatcher': { type: 'cn', min: '1', max: '3' },
    },
    'sticker sheet': { 'custom vinyl sticker sheet': { type: 'cn', min: '2', max: '3' } },
    'sticky note holder': { 'sticky note pad holder': { type: 'cn', min: '2', max: '3' } },
    stoles: { stoles: { type: 'cn', min: '2', max: '3' } },
    'storage box': { 'storage box': { type: 'cn', min: '3', max: '5' } },
    'suncatcher ornament': { 'suncatcher ornament': { type: 'cn', min: '3', max: '5' } },
    'sunglasses holder for car visor': { 'sunglasses holder for car visor': { type: 'cn', min: '2', max: '3' } },
    sweatpants: { sweatpants: { type: 'cn', min: '3', max: '5' } },
    sweatshirt: {
      'sweatshirt with sleeve imprint': { type: 'cn', min: '3', max: '5' },
      'unisex sweatshirt with design on sleeve': { type: 'cn', min: '3', max: '5' },
    },
    't shirt printed front & sleeves': { 't shirt': { type: 'us', min: '1', max: '3' } },
    't-shirt': {
      't shirt': { type: 'us', min: '1', max: '2' },
      'adult & kid combo t shirts': { type: 'us', min: '1', max: '2' },
      'combo t shirt and baby onesie': { type: 'cn', min: '1', max: '2' },
    },
    'tape measure': {
      'tape measure': { type: 'cn', min: '1', max: '3' },
      'tape measure azcs': { type: 'amz', min: 1, max: 1 },
    },
    'toiletry bag': { 'toiletry bag': { type: 'cn', min: '3', max: '5' } },
    'tote bag': { 'tote bag': { type: 'cn', min: '2', max: '3' } },
    'tracker bottle': { 'water tracker bottle': { type: 'cn', min: '2', max: '3' } },
    'triple can cooler': { 'triple 3 in 1 can cooler': { type: 'cn', min: '1', max: '3' } },
    tumbler: {
      tumbler: { type: 'cn', min: '1', max: '3' },
      '40oz tumbler with straw': { type: 'cn', min: '1', max: '3' },
      '14oz stainless steel tumbler with handle': { type: 'cn', min: '1', max: '3' },
      'tumbler 20oz azcs': { type: 'amz', min: 1, max: 1 },
      '40oz tumbler azcs': { type: 'amz', min: 1, max: 1 },
    },
    'tumbler 30oz': { '30 oz tumbler': { type: 'cn', min: '1', max: '3' } },
    'turkish beach towel': { 'turkish beach towel': { type: 'cn', min: '3', max: '5' } },
    'ugly sweater': {
      'unisex ugly sweater': { type: 'cn', min: '3', max: '5' },
      'kid ugly sweater': { type: 'cn', min: '3', max: '5' },
      'baby sweater': { type: 'cn', min: '3', max: '5' },
    },
    'unisex tank tops': { 'unisex tank tops': { type: 'cn', min: '2', max: '3' } },
    'vintage washed denim cap': { 'vintage washed denim cap': { type: 'cn', min: '2', max: '3' } },
    'warm mittens': { 'warm mittens': { type: 'cn', min: '3', max: '5' } },
    'waterproof phone pouch': { 'waterproof phone pouch': { type: 'cn', min: '2', max: '3' } },
    'wearable blanket': { 'wearable blanket': { type: 'cn', min: '3', max: '5' } },
    'wearable hooded blanket': { 'wearable hooded blanket': { type: 'cn', min: '3', max: '5' } },
    'whiskey bottle': { 'whiskey bottle': { type: 'cn', min: '2', max: '3' } },
    'whiskey glass': {
      'engraved whiskey glass': { type: 'cn', min: '1', max: '3' },
      'whiskey glass': { type: 'cn', min: '1', max: '3' },
    },
    'white flat ball ornament': { 'white flat ball ornament': { type: 'cn', min: '2', max: '3' } },
    'wind spinner': { 'wind spinner': { type: 'cn', min: '2', max: '3' } },
    'window corner suncatcher': { 'window corner suncatcher': { type: 'cn', min: '2', max: '3' } },
    'window hanging suncatcher': { 'window hanging suncatcher ornament': { type: 'cn', min: '2', max: '3' } },
    'wine bottle wind chime': { 'wine bottle wind chime': { type: 'cn', min: '2', max: '3' } },
    'wine glass': {
      'stemless wine glass': { type: 'cn', min: '1', max: '3' },
      'wine glass': { type: 'cn', min: '1', max: '3' },
    },
    'wine tumbler': { 'wine tumbler': { type: 'cn', min: '1', max: '3' } },
    'women kimono cardigan': { 'women kimono cardigan': { type: 'cn', min: '3', max: '5' } },
    "women's sleep tee": { "women's sleep tee": { type: 'cn', min: '3', max: '5' } },
    'wood book ends': { 'wood book ends': { type: 'cn', min: '2', max: '3' } },
    'wood circle sign': { 'wood circle sign': { type: 'cn', min: '2', max: '3' } },
    'wood key holder': {
      'wood key holder': { type: 'cn', min: '2', max: '3' },
      'custom shaped key holder': { type: 'cn', min: '2', max: '3' },
    },
    'wood rectangle sign': { 'wood rectangle sign': { type: 'cn', min: '2', max: '3' } },
    'wood sculpture table': { 'wood sculpture table ornament': { type: 'cn', min: '2', max: '3' } },
    'wood shaped sign': {
      'custom shaped wood sign': { type: 'cn', min: '2', max: '3' },
      'custom shaped wood sign with wooden tags': { type: 'cn', min: '2', max: '3' },
    },
    'wood slice ornament': { 'wood slice ornament': { type: 'cn', min: '2', max: '3' } },
    'wooden card with ornament': {
      'wooden card with pop out medallion ornament': { type: 'cn', min: '2', max: '3' },
      'wooden card with pop out ornament': { type: 'cn', min: '2', max: '3' },
    },
    'wooden cutout ornament': { 'wooden cutout ornament': { type: 'fast_cn', min: '1', max: '2' } },
    'wooden cutting board': { 'wooden cutting board': { type: 'cn', min: '2', max: '3' } },
    'wooden keychain': {
      'wooden keychain': { type: 'cn', min: '2', max: '3' },
      'cutout wooden keychain': { type: 'cn', min: '2', max: '3' },
    },
    'wooden mug': { 'wooden mug': { type: 'cn', min: '2', max: '3' } },
    'wooden ornament': {
      'custom shaped wooden ornament': { type: 'fast_cn', min: '1', max: '2' },
      'medallion wooden ornament': { type: 'fast_cn', min: '1', max: '2' },
      'wooden ornament print 2 sides': { type: 'cn', min: '1', max: '3' },
    },
    'wooden ornament with wooden tags': { 'wooden ornament with wooden tags': { type: 'cn', min: '3', max: '5' } },
    'wooden pen pencil holder': { 'wooden pen pencil holder': { type: 'cn', min: '2', max: '3' } },
    'wooden pen set': { 'wooden pen set': { type: 'cn', min: '2', max: '3' } },
    'wooden plaque': {
      '2-layered wooden plaque with stand': { type: 'cn', min: '2', max: '3' },
      'custom shaped 2-layered wooden plaque': { type: 'cn', min: '2', max: '3' },
    },
    'wooden puzzle': { 'custom shaped wooden puzzle': { type: 'cn', min: '2', max: '3' } },
    'wool scarf with tassel': { 'wool scarf with tassel': { type: 'cn', min: '3', max: '5' } },
    'yoga towel': { 'yoga towel': { type: 'cn', min: '2', max: '3' } },
    'zippered canvas bag': { 'zippered canvas bag': { type: 'cn', min: '3', max: '5' } },
    'crochet portrait doll': { 'crochet portrait doll': { type: 'cn', min: '5', max: '7' } },
    'keepsake jar': { 'ceramic pet-shaped keepsake jar': { type: 'cn', min: '10', max: '14' } },
    'hooded jumpsuit':{
      'overall onesie hooded jumpsuit':{ type: 'cn', min: '3', max: '5' } ,
    },
    default: { other: { type: 'cn', min: 2, max: 3 } },
  },
  orderShippingTime = {
    cn: {
      us: { min: 6, max: 10 },
      gb: { min: 6, max: 10 },
      ca: { min: 6, max: 10 },
      au: { min: 8, max: 13 },
      de: { min: 7, max: 11 },
      it: { min: 7, max: 11 },
      ie: { min: 7, max: 11 },
      fr: { min: 6, max: 10 },
      nl: { min: 6, max: 10 },
      es: { min: 6, max: 10 },
      default: { min: 8, max: 13 },
    },
    us: {
      us: { min: 3, max: 5 },
      gb: { min: 6, max: 10 },
      ca: { min: 6, max: 10 },
      au: { min: 8, max: 13 },
      de: { min: 7, max: 11 },
      it: { min: 7, max: 11 },
      ie: { min: 7, max: 11 },
      fr: { min: 6, max: 10 },
      nl: { min: 6, max: 10 },
      es: { min: 6, max: 10 },
      default: { min: 8, max: 13 },
    },
    fast_cn: {
      us: { min: 3, max: 5 },
      gb: { min: 6, max: 10 },
      ca: { min: 6, max: 10 },
      au: { min: 8, max: 13 },
      de: { min: 7, max: 11 },
      it: { min: 7, max: 11 },
      ie: { min: 7, max: 11 },
      fr: { min: 6, max: 10 },
      nl: { min: 6, max: 10 },
      es: { min: 6, max: 10 },
      default: { min: 8, max: 13 },
    },
    blanket: { //deprecated
      us: { min: 3, max: 6 },
      gb: { min: 6, max: 10 },
      ca: { min: 6, max: 10 },
      au: { min: 8, max: 13 },
      de: { min: 7, max: 11 },
      it: { min: 7, max: 11 },
      ie: { min: 7, max: 11 },
      fr: { min: 6, max: 10 },
      nl: { min: 6, max: 10 },
      es: { min: 6, max: 10 },
      default: { min: 8, max: 13 },
    },
    amz: { us: { min: 3, max: 5 }, default: { min: 5, max: 7 } },
    default: { default: { min: 8, max: 13 } },
  };
window.estimateShipping = { orderHandlingTime, orderShippingTime };
//# sourceMappingURL=/s/files/1/0949/1454/3899/files/est_shipping_config_v2_1_0_1.js.map
